import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export function LegalPageLayout({ eyebrow, title, description, updatedAt, children }) {
  return (
    <>
      <section className="relative overflow-hidden bg-navy pt-36 pb-16 md:pt-44 md:pb-20">
        <div className="grid-lines-dark absolute inset-0 opacity-50" />
        <div className="absolute inset-0 bg-gradient-to-br from-navy via-navy/95 to-dark" />
        <div className="relative mx-auto max-w-[1100px] px-5 md:px-8">
          <div className="mb-6 flex items-center gap-2 text-xs text-silver/60">
            <Link to="/" className="transition-colors hover:text-cyan">Ana Sayfa</Link>
            <ChevronRight className="h-3 w-3" />
            <span className="text-cyan">{eyebrow}</span>
          </div>
          <div className="mb-5 flex items-center gap-3">
            <span className="h-px w-10 bg-cyan" />
            <span className="text-xs font-semibold uppercase tracking-[0.24em] text-cyan">{eyebrow}</span>
          </div>
          <h1 className="max-w-4xl font-head text-4xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-5xl md:text-6xl">
            {title}
          </h1>
          {description ? <p className="mt-6 max-w-3xl text-base leading-relaxed text-silver/80 md:text-lg">{description}</p> : null}
          <p className="mt-7 text-xs uppercase tracking-[0.16em] text-silver/45">Son güncelleme: {updatedAt}</p>
        </div>
      </section>

      <section className="bg-light py-16 md:py-24">
        <article className="mx-auto max-w-[1000px] px-5 md:px-8">
          <div className="border border-ink/10 bg-white p-6 shadow-sm md:p-10 lg:p-12">
            <div className="legal-content">{children}</div>
          </div>
        </article>
      </section>
    </>
  );
}
